/* Kit4Kitchens preview batch 1: keep the sticky theme header below the BSS Product Labels fixed bar. Delete this file + its <script> in layout/theme.liquid to revert. */
(function(){
  var root=document.documentElement,ro=null,watched=null;
  function bar(){var w=document.querySelector('.bss-pl-banner-wrapper');return w?w.parentElement:null}
  function update(){
    var b=bar(),h=0;
    if(b&&b!==document.body){var cs=getComputedStyle(b);if(cs.display!=='none'&&cs.visibility!=='hidden'&&(cs.position==='sticky'||cs.position==='fixed')){h=Math.round(b.getBoundingClientRect().height)}}
    root.style.setProperty('--k4k-bss-offset',h+'px');
    if(b&&b!==watched&&window.ResizeObserver){if(ro)ro.disconnect();ro=new ResizeObserver(update);ro.observe(b);watched=b}
  }
  function init(){
    update();
    window.addEventListener('resize',update);
    window.addEventListener('load',update);
    if(window.MutationObserver){new MutationObserver(update).observe(document.body,{childList:true})}
    var n=0,t=setInterval(function(){update();if(++n>20)clearInterval(t)},500);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
